
import { useQuery,} from '@tanstack/react-query';
import { useSettlementsApi } from '../../hooks/useSettlementsAPI';

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  userType?: string;
  userId?: string;
  transactionType?: 'toPay' | 'toReceive' | 'completed' | 'all';
  fromDate?: string;
  toDate?: string;
  search?: string;
};

export const useGetSettlements = (queryParams: Params, options?: { enabled?: boolean }) => {
  const { getAllSettlements } = useSettlementsApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: [
      'getSettlements',
     queryParams
    ],
    queryFn: () => {
      return getAllSettlements(queryParams);
    },
    enabled: options?.enabled ?? true,
    ...options
  });


  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};


